const footerForm = document.querySelector('.js-footer-form')

if (footerForm) {
  const messageField = footerForm.querySelector('.js-footer-form-message')
  const additionalFields = footerForm.querySelectorAll('.js-footer-form-additional')

  for (let i = 0; i < additionalFields.length; i++) {
    additionalFields[i].style.display = 'none'
  }

  messageField.addEventListener('focus', () => {
    for (let i = 0; i < additionalFields.length; i++) {
      additionalFields[i].style.display = ''
    }

    messageField.setAttribute('rows', '8')
  })
}



// WEBPACK FOOTER //
// ./src/components/footer-contact/scripts.js